import React, { useState, useEffect, useRef, useCallback } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import Report from '../../../Report/Report';
import DragScroll from '../../../../utils/DragScroll';

const StatisticsTable = ({ data, headerName, loading, order, sort, metrics, keysMetric, rowsCount, onAction, t }) => {
    const [state, setState] = useState({
        data: data,
        headerName: headerName,
        loading: loading,
        order: order,
        sort: sort,
        metrics: metrics,
        keysMetric: keysMetric,
        isSorting: true,
        isTableFirst: true
    });

    const bodyRef = useRef(null);

    const setBodyData = useCallback(() => {
        if (bodyRef.current) {
            bodyRef.current.innerHTML = state.data;
        }
    }, [state.data]);

    useEffect(() => {
        setBodyData();
        new DragScroll({ className: 'table-responsive' });
    }, []);

    useEffect(() => {
        const isChangeData = data !== state.data;

        setState(prevState => ({
            ...prevState,
            data: data,
            headerName: headerName,
            loading: loading,
            order: order,
            sort: sort,
            metrics: metrics,
            keysMetric: keysMetric
        }));

        if (isChangeData) {
            setBodyData();
        }
    }, [data, headerName, loading, order, sort, metrics, keysMetric, setBodyData]);

    return (
        <Report
            {...state}
            rowsCount={rowsCount}
            onAction={onAction}
            t={t}
            bodyRef={bodyRef}
            tableWrapperClass={{
                'table-responsive_compact-report': true
            }}
        />
    );
};

StatisticsTable.propTypes = {
    data: PropTypes.string,
    headerName: PropTypes.array,
    loading: PropTypes.bool,
    order: PropTypes.string,
    sort: PropTypes.string,
    metrics: PropTypes.string,
    keysMetric: PropTypes.array,
    rowsCount: PropTypes.number,
    onAction: PropTypes.func,
    t: PropTypes.object
};

StatisticsTable.defaultProps = {
    data: '',
    headerName: [],
    loading: false,
    order: 'desc',
    sort: '',
    metrics: '',
    keysMetric: [],
    rowsCount: 0,
    onAction: () => {}
};

export default withTranslation(StatisticsTable);
